import ChatRequestVariablesHint from '@components/ChatRequestVariablesHint'
import { Localizable } from '@components/localizable/Localizable'
import { Alert, Typography } from 'antd'

const { Text } = Typography

/**
 * The chat-request half of the event form: what picking that booking method
 * actually does, and the optional per-event override of the program's
 * message. Create and Update are mirrors of one another, so this lives in one
 * place rather than being kept in step by hand.
 */
const ChatRequestFields = () => {
  return (
    <>
      <Alert
        style={{ marginBottom: 16 }}
        title="Members are sent to the program's chat channel (Intercom or WhatsApp), set per program under Membership › Programs › Concierge › Chat."
        type="info"
      />
      <Localizable.TextArea
        label={'Message override'}
        name={'eventChatRequestMessage'}
        rules={[]}
        max={500}
      />
      <ChatRequestVariablesHint />
      <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
        Leave empty to use the program's chat request message.
      </Text>
    </>
  )
}

export default ChatRequestFields
